import React from 'react';
import { Trash2, X } from 'lucide-react';
import { EARTH, CONNECTOR_COLORS } from '../theme/constants';

export function ConnectorToolbar({ arrow, position, onChangeColor, onDelete, onClose }) {
  if (!arrow || !position) return null;

  return (
    <div
      className="absolute z-50 p-2 rounded-xl shadow-xl flex items-center gap-2"
      style={{
        left: position.x,
        top: position.y,
        backgroundColor: '#fff',
        border: '1px solid ' + EARTH.stone[200],
        transform: 'translate(-50%, -100%) translateY(-10px)'
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex gap-1">
        {CONNECTOR_COLORS.map(c => (
          <button
            key={c.id}
            onClick={(e) => { e.stopPropagation(); onChangeColor(c.id); }}
            className="w-5 h-5 rounded-full border-2 transition-transform hover:scale-110"
            style={{
              backgroundColor: c.color,
              borderColor: arrow.color === c.id ? EARTH.stone[800] : 'transparent'
            }}
          />
        ))}
      </div>
      <div className="w-px h-5" style={{ backgroundColor: EARTH.stone[200] }} />
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (onDelete && arrow) {
            onDelete(arrow);
          }
        }}
        className="p-2 rounded hover:bg-red-50"
        style={{ color: EARTH.terracotta[500] }}
        title="Delete connection"
      >
        <Trash2 className="w-5 h-5" />
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="p-2 rounded hover:bg-stone-100"
        style={{ color: EARTH.stone[400] }}
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}
